export const REFERRER_CTA = {
  REPORT: 'report',
  QUOTES: 'quotes',
  DASHBOARD: 'dashboard'
};
